import { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import VerbText from '../../../shared/components/VerbText';

import createAdminCardsArray from './LandingPageCards';
import { RuntimeContext } from '../../../../common/RuntimeContext';

const AdminLandingPage = (props) => {
    const config = useContext(RuntimeContext);
    const { history, isCompanyReportViewer, isAccountOwner, loggedInUserId, loggedInUserCompanyId } = props;

    if (!isAccountOwner && isCompanyReportViewer) {
        history.push('/admin/measure/engagement');
    }
    const cardsArray = createAdminCardsArray(props);

    return (
        <div className={'container top-of-admin-landing-page'}>
            <div className={'row'}>
                {cardsArray.map((card) => (
                    <div className={'col-12 col-sm-6 col-md-4'}>
                        <Link to={card.link} className={'boxxy row'}>
                            <p className={'collection-title col-12'}>
                                <VerbText
                                    messageId={card.messageId}
                                    defaultMessage={card.defaultMessage}
                                    description={card.description}
                                />
                            </p>
                            <div className={'col-12'}>
                                <i className={card.iconClasses}></i>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const {
        auth: {
            isVerbAdmin,
            isAccountOwner,
            loggedInUserId,
            loggedInUser,
            loggedInUserCompanyId,
            isContentReviewer,
            isContentAuthor,
            isContentAdmin,
            isCompanyReportViewer,
            companyPermalink
        }
    } = state;
    return {
        isVerbAdmin,
        isAccountOwner,
        loggedInUserId,
        loggedInUser,
        loggedInUserCompanyId,
        isContentReviewer,
        isContentAuthor,
        isContentAdmin,
        isCompanyReportViewer,
        companyPermalink
    };
};

AdminLandingPage.propTypes = {
    history: PropTypes.object,
    isCompanyReportViewer: PropTypes.bool,
    isAccountOwner: PropTypes.bool,
    loggedInUserId: PropTypes.string,
    loggedInUserCompanyId: PropTypes.string
};

export default connect(mapStateToProps, null)(AdminLandingPage);
